import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

/** The layout under `/ws/david`: guarded by his own entry (`maintenance:read`, and his plan). */
export const Route = createFileRoute("/_authenticated/ws/david")({
  beforeLoad: ({ context }) => guardRoute(context.me, "maintenance-agent"),
  component: Outlet,
});
